"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.payment = void 0;
const axios_class_1 = require("./axios.class");
class Payment {
    async fetchConnectionToken() {
        const { data } = await axios_class_1.axios.get('/payment/token');
        return data.secret;
    }
    async createPaymentIntent(productId) {
        const { data } = await axios_class_1.axios.post('/payment/createDAN', {
            productId
        });
        return data.client_secret;
    }
    async initiatePaymentForPOS(productId, posId) {
        const { data } = await axios_class_1.axios.post('/payment/initiatePaymentForPOS', {
            productId,
            posId
        });
        return data;
    }
    async getPOSStatus(posId) {
        const { data } = await axios_class_1.axios.post('/payment/getPOSStatus', {
            posId
        });
        return data;
    }
    async cancelPaymentForPOS(posId) {
        const { data } = await axios_class_1.axios.post('/payment/cancelPaymentForPOS', {
            posId
        });
        return data;
    }
    async createCheckoutSession(productId, address, externalId) {
        const { data } = await axios_class_1.axios.post('/payment/createCheckoutSession', {
            productId,
            address,
            externalId
        });
        return data.url;
    }
    async capturePayment(paymentIntentId, productId, address, externalId) {
        return axios_class_1.axios.post('/payment/captureDAN', {
            paymentIntentId,
            productId,
            address,
            externalId
        });
    }
    async capturePaymentV2(paymentIntentId, address, externalId) {
        return axios_class_1.axios.post('/v2/payment/captureDAN', {
            paymentIntentId,
            address,
            externalId
        });
    }
    async sendReceipt(paymentIntentId, phone) {
        try {
            await axios_class_1.axios.post('/payment/receipt', {
                paymentIntentId,
                phone
            });
            return true;
        }
        catch (_a) {
            return false;
        }
    }
    async initiatePaymentSession(productId, marketplaceId, address) {
        try {
            const { data } = await axios_class_1.axios.post('/v1/payment/initiatePaymentSession', {
                productId: productId,
                marketplaceId: marketplaceId,
                address: address
            });
            axios_class_1.axios.setAuthorization(data.token);
            return data;
        }
        catch (e) {
            console.log({ e });
            return {};
        }
    }
}
exports.payment = new Payment();
